import { useTranslation } from "../../i18n/LanguageContext";

export default function StatsBar() {
  const { t } = useTranslation();
  return (
    <section
      data-testid="stats-bar"
      className="relative border-t border-b border-white/[0.06] bg-[#dfd3ee]"
    >
      <div aria-hidden className="pointer-events-none absolute inset-x-0 bottom-0 h-12 md:h-20 bg-gradient-to-b from-transparent to-[#ebe2f5]" />
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 py-8 md:py-12 grid grid-cols-2 lg:grid-cols-4 gap-y-7 sm:gap-y-10 gap-x-5 sm:gap-x-6">
        {t.stats.map((s, i) => {
          const Icon = s.icon;
          return (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="flex items-center gap-3 sm:gap-5"
            >
              <span className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-[#0a0a0a]/30 flex items-center justify-center shrink-0">
                <Icon size={18} className="text-[#0a0a0a]" strokeWidth={1.4} />
              </span>
              <div>
                <div className="font-serif-display text-2xl sm:text-3xl md:text-4xl gold-text leading-none">
                  {s.value}
                </div>
                <div className="mt-1 sm:mt-1.5 text-[10px] sm:text-xs md:text-sm tracking-wider uppercase text-[#8a7f8f] leading-tight">
                  {s.label}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
